"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: subheadlineRef,
    isVisible: subheadlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background !bg-[url(https://sloane.uk/wp-content/uploads/2026/02/Phone-1680x958-1.png)]">
      {}
      

      {}
      <div className="relative z-10 max-w-4xl mx-auto px-6 py-24 text-center">
        {}
        <h1 ref={headlineRef} className="text-[48px] leading-[1.2] font-bold tracking-[-0.2px] mb-6 transition-all duration-700 ease-out opacity-100 translate-y-0 !text-[hsl(0,0%,100%)] md:text-[60px]" style={{
        transitionDelay: "150ms"
      }}>Market Leading Protection For Our Clients</h1>

        {}
        <p ref={subheadlineRef} className="text-[20px] leading-[1.5] font-normal mb-10 transition-all duration-700 ease-out opacity-100 translate-y-0 !text-[hsl(210,16%,93%)] md:text-[24px]" style={{
        transitionDelay: "300ms"
      }}>Tax Fee Protection Service</p>

        {}
        <div ref={ctaRef} className={`flex flex-col items-center gap-4 transition-all duration-700 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
        transitionDelay: "450ms"
      }}>
          {}
          <Button asChild size="lg" className="rounded-[30px] px-8 py-6 text-[18px] font-semibold shadow-medium hover:shadow-strong hover:-translate-y-1 transition-all duration-200 ease-out animate-pulse-subtle hover:bg-primary-hover">
            
          </Button>

          {}
          <Link to="#key-benefits" className="text-[16px] font-medium text-primary hover:text-primary-active underline-offset-4 hover:underline transition-colors duration-200">
            Learn more about our services
          </Link>
        </div>
      </div>

      {}
      <style>{`
        @keyframes pulse-subtle {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.95;
            transform: scale(1.02);
          }
        }
        .animate-pulse-subtle {
          animation: pulse-subtle 3s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
      `}</style>
    </section>;
}